module.exports = __webpack_public_path__ + "img/coins-stacked-02.ee567a09.svg";